import { render, staticRenderFns } from "./modifyPhone.vue?vue&type=template&id=6ad28418&scoped=true"
import script from "./modifyPhone.vue?vue&type=script&lang=js"
export * from "./modifyPhone.vue?vue&type=script&lang=js"
import style0 from "./modifyPhone.vue?vue&type=style&index=0&id=6ad28418&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad28418",
  null
  
)

export default component.exports